import { queryStringify } from '@utils'
import { createMutationHelper, createRequestHelper } from '@utils/swr'
import { type AxiosPromise } from 'axios'
import { type FastpassPaymentRequest } from '../types/apiRequest'
import { type FastpassPaymentResponse } from '../types/apiResponse'
import { type FortuneApis } from '../types/apis'
import { fortunePaymentsQueue } from './fortunePaymentsQueue'

const { useMutation } = createMutationHelper<FortuneApis['get']['payment'], FastpassPaymentResponse, FastpassPaymentRequest>({
  client: 'fortune',
  key: '/payment/payment',
  fetcher: (url, { arg, client }) => {
    if (!arg) {
      throw new Error('[useApiGetFpPayment] Argument is required!')
    }
    const { order_type, payment_method_id } = arg

    if (!order_type) {
      throw new Error('[useApiGetFpPayment] order_type is required!')
    }
    if (!payment_method_id) {
      throw new Error('[useApiGetFpPayment] payment_method_id is required!')
    }
    const dynamicUrl = `${url}?${queryStringify(arg)}`

    return fortunePaymentsQueue.add(() => client.get(dynamicUrl)) as AxiosPromise<FastpassPaymentResponse>
  },
})

export const useApiGetFpPayment = useMutation

const { useRequest } = createRequestHelper<FortuneApis['get']['payment'], FastpassPaymentResponse, FastpassPaymentRequest>({
  client: 'fortune',
  key: (params) => {
    if (!params) return null
    const { order_type, payment_method_id } = params
    if (!order_type || !payment_method_id) return null
    return `/payment/payment?${queryStringify(params)}`
  },
  fetcher: client => (url, arg) => {
    if (!arg) {
      throw new Error('[useApiGetFpPayment] Argument is required!')
    }
    const { order_type, payment_method_id } = arg

    if (!order_type) {
      throw new Error('[useApiGetFpPayment] order_type is required!')
    }
    if (!payment_method_id) {
      throw new Error('[useApiGetFpPayment] payment_method_id is required!')
    }
    const dynamicUrl = `${url}?${queryStringify(arg)}`

    return fortunePaymentsQueue.add(() => client.get(dynamicUrl)) as AxiosPromise<FastpassPaymentResponse>
  },
})

export const useApiGetFpPaymentRequest = useRequest
